import { Label, defineLabels } from './types';

/**
 * A SECOND KEYSPACE: keyed by table name, not by column.
 *
 * `order_sale_products` → "Producto", `user_roles` → "Rol". These name the
 * child collection a diff row came from, so the row reads "Producto BOLSA 20x30
 * · Precio por kilo" instead of "order_sale_products #754 · kilo price".
 *
 * Only the audit reads this — forms and tables have no equivalent surface — so
 * only `long` will ever be filled.
 *
 * It must not be merged into `FIELD_LABELS`. `check-activity-labels.cjs`
 * cross-references that map against the Prisma schema's *columns*; a table name
 * has no column to check against. Today the script only walks schema → labels,
 * so stray keys would not break it, but the reverse check is worth adding later
 * (it is what catches a renamed column leaving a dead label behind) and mixing
 * the keyspaces forecloses it.
 */
export const COLLECTION_LABELS = defineLabels({
    order_sale_products: { long: 'Producto' },
    expense_resources: { long: 'Material' },
    transfer_receipts: { long: 'Aplicado a' },
    order_request_products: { long: 'Producto' },
    order_quotation_products: { long: 'Producto' },
    order_adjustment_products: { long: 'Producto' },
    order_production_products: { long: 'Producto' },
    order_production_products_consumed: { long: 'Material' },
    order_production_employees: { long: 'Empleado' },
    account_products: { long: 'Producto' },
    account_resources: { long: 'Material' },
    account_contacts: { long: 'Contacto' },
    user_roles: { long: 'Rol' },
});

export type CollectionLabelKey = keyof typeof COLLECTION_LABELS;

/** Dynamic lookup — see the note on `lookupFieldLabel`. */
export function lookupCollectionLabel(collection: string): Label | undefined {
    return (COLLECTION_LABELS as Record<string, Label | undefined>)[collection];
}
